class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      console.log('[CartRemoveButton] clicked, data-index:', this.dataset.index);

      // Convert to 1-based index for Shopify API
      const lineIndex = parseInt(this.dataset.index, 10) + 1;
      cartItems.updateQuantity(lineIndex, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus') ||
      null;

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value, 10), 0);

    this.debouncedOnChange = debounce((event) => this.onChange(event), 300);
    this.addEventListener('change', this.debouncedOnChange);
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble'
      },
      {
        id: 'cart-cta-buttons',
        section: 'cart-cta-buttons',
        selector: '#cart-cta-buttons'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line: parseInt(line, 10),
      quantity: parseInt(quantity, 10),
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body
    })
      .then(res => res.text())
      .then(text => {
        const parsedState = JSON.parse(text);
        const isEmpty = parsedState.item_count === 0;
        this.classList.toggle('is-empty', isEmpty);

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.toggle('is-empty', isEmpty);
          const emptyMessage = drawer.querySelector('.drawer__empty-message-row');
          const itemsWrapper = drawer.querySelector('.drawer__cart-items-wrapper');
          const checkoutBtn = drawer.querySelector('#CartDrawer-Checkout');

          if (emptyMessage) emptyMessage.style.display = isEmpty ? 'table-row' : 'none';
          if (itemsWrapper) itemsWrapper.style.display = isEmpty ? 'none' : 'block';
          if (checkoutBtn) checkoutBtn.toggleAttribute('disabled', isEmpty);
        }

        this.getSectionsToRender().forEach(section => {
          const html = parsedState.sections[section.section];
          if (!html) return;

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newContent = parsed.querySelector(section.selector);
          const container = document.querySelector(section.selector);

          if (container && newContent) {
            container.innerHTML = newContent.innerHTML;
          } else {
            console.warn(`[CartItems] Could not update section "${section.section}" — selector missing: ${section.selector}`);
          }
        });

        // Ensure UI always shows header, totals, CTA, and footer
        const header = drawer?.querySelector('.drawer__header');
        const totals = drawer?.querySelector('.drawer__footer');
        if (header) header.style.display = 'block';
        if (totals) totals.style.display = 'block';

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        const focusTarget = name && lineItem?.querySelector(`[name="${name}"]`);

        try {
          if (focusTarget && drawer) {
            trapFocus(drawer, focusTarget);
          } else if (isEmpty && drawer?.querySelector('.drawer__inner-empty')) {
            trapFocus(drawer.querySelector('.drawer__inner-empty'), drawer.querySelector('a'));
          } else if (document.querySelector('.cart-item') && drawer) {
            trapFocus(drawer, document.querySelector('.cart-item__name'));
          }
        } catch (err) {
          console.warn('[CartItems] trapFocus error:', err);
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.disableLoading();
      })
      .catch(err => {
        console.error('[CartItems] ❌ updateQuantity failed:', err);
        this.querySelectorAll('.loading-overlay').forEach(o => o.classList.add('hidden'));
        const errEl = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errEl) errEl.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const err = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const qtyInput = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      if (err && qtyInput) {
        err.querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', qtyInput.value);
      }
    }
    this.currentItemCount = itemCount;
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const live = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (live) {
      live.setAttribute('aria-hidden', false);
      setTimeout(() => live.setAttribute('aria-hidden', true), 1000);
    }
  }

  enableLoading(line) {
    const container = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.add('cart__items--disabled');

    const overlays = [
      ...this.querySelectorAll(`#CartItem-${line} .loading-overlay`),
      ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)
    ];
    overlays.forEach(o => o.classList.remove('hidden'));

    document.activeElement?.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const container = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.remove('cart__items--disabled');
  }
}
customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce(event => {
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({ note: event.target.value })
        });
      }, 300));
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('#shopify-section-template--14640122658852__cart-items .continue-shopping-button');
  if (btn) btn.href = document.referrer || '/collections/all';
});
